import React from "react";
import { usePublishedQuestionnairePreview } from "../../queries";
import type { PreviewAttrs } from "../../api";
import { ResolvedQuestionnaireContent } from "./QuestionnairePreview";
import { PatientPreviewShell } from "./PatientPreviewShell";

const PublishedQuestionnairePreview: React.VFC<{
  id: number;
  attrs: PreviewAttrs;
  onAttrsChange: (attrs: PreviewAttrs) => void;
  currentPageIndex?: number;
  onPageIndexChange?: (index: number) => void;
}> = ({ id, attrs, onAttrsChange, currentPageIndex, onPageIndexChange }) => {
  const resolvedPageIndex = currentPageIndex ?? 0;
  const setResolvedPageIndex = onPageIndexChange ?? (() => {});

  const { data: previewData, isLoading, error } = usePublishedQuestionnairePreview(id, attrs);

  return (
    <PatientPreviewShell
      isExpanded={false}
      onToggleExpand={() => {}}
      isLoading={isLoading}
      error={error}
      attrs={attrs}
      onApplyAttrs={next => {
        onAttrsChange(next);
        setResolvedPageIndex(0);
      }}
    >
      {previewData?.questionnaire && (
        <ResolvedQuestionnaireContent
          questionnaire={previewData.questionnaire}
          currentPageIndex={resolvedPageIndex}
          onPageIndexChange={setResolvedPageIndex}
        />
      )}
    </PatientPreviewShell>
  );
};

export default PublishedQuestionnairePreview;
